import * as modules from "constants/features"

export const PLANS = {
	BASE_PLAN: "base_plan",
	FULL_PLAN: "full_plan",
}

export const BASE_PLAN_ALLOWED_SUBMODULES = [modules.SELLOUT_REPORT_SUBMODULE]
